export default __webpack_public_path__ + "static/media/step3.b6068417.jpg";